import { render } from "./LogoutButtonComponent.vue?vue&type=template&id=1eac3e1c"
import script from "./LogoutButtonComponent.vue?vue&type=script&lang=js"
export * from "./LogoutButtonComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__